import enLocale from 'element-ui/lib/locale/lang/en'

export default {
  ...enLocale,
  language: {
    name: 'English',
    key: 'Mid文',
  },
  scds: {
    platform_0: "CN",
    platform_1: "HK",
    platform_2: "TM",
    platform_5: "JD",
    platform_6: "ROOKIE",
    platform_7: "NBA",
    platform_8: "VHALL",
    platform_9: "DY",
    platform_11: "JD.COM FLG",
    platform_12: "JD.COM YA"
  },
  attribution: {
    fileUpload: 'File Upload',
    attributeCalculate: 'Attribution Calculate',
    attribution: 'Attribution',
    InSeasonDownload: 'Download In-Season',
    ProcessLog: 'Publish Log',
    Calculate: 'Attribute Calculate',
    Publist: 'Publist',
    Chinese: '简中',
    English: 'EN',
    download: 'Download',
    InSeason: 'InSeason',
    AllProduct: 'All',
    Select: 'Selected',
    Filter: 'Filtered',
    search: 'Search',
    clear: 'Reset',
    ChooseFile: 'ChooseFile',
    choose: 'Choose',
    Upload: 'Upload',
    fileType: 'fileType',
    fileType_1_1: "TM LOC",
    fileType_1_2: "Wash Label",
    fileType_1_3: "Global Attribute",
    fileType_1_4: "China GB Code",
    status: 'status',
    status_0: 'pending',
    status_1: 'accomplish',
    status_2: 'error',
    status_3: 'being processed',
    cancel: 'Cancel',
    confirm: 'confirm',
    close: 'Close',
    pleaseUploadFile: "Please upload file!",
    uploading: "Uploading...",
    upload: "Upload",
    pleaseChooseFile: "Please choose file!",
    addAttribution: "Add Attribution",
    selAttribution: "Select Attribution For Calculate",
    detail: "Log Detail",
    calculationRange: "Calculation Range",
    formulaMode: "Formula Mode",
    calculateAttribution: "Attribution",
    inSeason: "InSeason",
    selected: "Selected",
    Intelligent: "Intelligent",
    All: "All",
    dataRange: "Data Range",
    dataSize: "Data Size",
    file: "file",
    info: "Info",
    pleaseChooseDetail: "Please choose detail!",
    uploadSuccess: "Upload Success!",
    uploadFailed: "Upload Failed!",
    downloadFailed: "Download Failed!",
    running: "Running",
    error: "Error",
    ok: "Ok",
    publish: "Publish",
    publishError: "Release failed, please try later",
    publishOk: "Publish success!",
    pleaseChooseDataRange: "Please choose dataRange!",
    pleaseChoosePlatform: "Please choose platform!",
    pleaseChooseDataSize: "Please choose dataSize!",
    calculating: "The system starts calculating!",
    pleaseChooseCalculationRange: "Please choose Calculation Range!",
    pleaseChooseFormulaMode: "Please choose Formula Mode!",
    pleaseChooseCalculateAttribution: "Please choose Attribution!",
    hasCalculating: "Do not perform repeated operations during property calculation!",
    startTime: "Start Time",
    endTime: "End Time",
    triggerBy: "Trigger By",
    platform: "Platform",
    elapsedTime: "Elapsed Time(S)",
    logStatus: "Status",
    inputValue: "Input Value",
    cause: "Cause",
    configuration: "Configuration",
    sku: 'SKU',
    calculateResult: 'Calculate Result',
    latestRelease: 'Latest Release'
  },
  fitReport: {
    fileUpload: 'File Upload',
    dataManage: 'Data Management',
    fileType: 'File type',
    ChooseFile: 'ChooseFile',
    fileType_2_1: 'Fitting Report',
    fileType_2_2: 'YA Fitting Report',
    fileType_2_3: 'CS VOC',
    productName: 'Product Name',
    diagnosisErrorCode1: 'Content is not numerical',
    diagnosisErrorCode2: 'The content cannot be empty',
    diagnosisErrorCode3: 'Contains forbidden/sensitive/negative words',
    diagnosisErrorCode4: 'Use punctuation marks at the end of sentences',
    diagnosisErrorCode5: 'Exceed the word limit',
    diagnosisErrorCode6: 'The content is invalid',
    diagnosisErrorCode7: 'The content cannot contain English',
    upload: 'Upload',
    search: 'Search',
    download: 'Data Download',
    downloadImage: 'Image Download',
    selSeason: 'Please select season',
    excelName: "File name",
    createUser: "Operator",
    createTime: "Upload time",
    status: 'Status',
    status_0: 'pending',
    status_1: 'accomplish',
    status_2: 'error',
    status_3: 'being processed',
    addSeason: 'Add Season',
    editSeason: 'Edit Season',
    season: 'season',
    tryToFeel: "Try To Feel",
    pleaseChooseFile: "Please choose file!",
    uploading: "Uploading...",
    saveInfo: "Do you want to save?",
    saveInfoIsNull: "The content cannot be empty,please input!",
    productCategory: "product category",
    fitExperience: "fit experience",
    customerFeedback: "customer feedback",
    commentCount: "comment count",
    diagnosisStatus: "diagnosis status",
    negativeJudgement: "negative judgement",
    newSeason: "new season",
    publishStatus: "publish status",
    operate: "operate",
    pleaseChooseDetail: "Please choose detail!",
    downloadFailed: "Download Failed!",
    detail: "detail",
    published: "Published",
    unpublished: "Unpublished",
    normal: "Normal",
    abnormal: "Abnormal",
    warning: "Warning",
    noFeedback: "No Feedback"
  },
  common: {
    resetPwd: 'Reset password',
    languageSwitch: 'Language',
    logout: 'Logout',
    no: "No.",
    operate: "Operate",
    list: "List",
    search: "Search",
    reset: "Reset",
    everyPageShow: "Each page show",
    to: "To",
    edit: "Edit",
    delete: "Delete",
    recovery: "Recovery",
    add: "Add",
    sure: "OK",
    cancel: "Cancel",
    close: "Close",
    startDate: "Start date",
    endDate: "End date",
    comfirm: "Confirm",
    confirm: "Confirm",
    detail: "Detail",
    up: "Move up",
    down: "Move down",
    top: "Top",
    bottom: "Bottom",
    ok: "OK",
    pleaseSelect: "Please select",
    pleaseInput: "Please input",
    refresh: "Refresh",
    prevPage: "Previous",
    nextPage: "Next",
    quit: "Quit",
    repeatSubmit: "Do not repeat submission",
    modifiedPassword: "Modified password",
    sysInfo: "System info",
    selectAll: "All",
    treate: "Treate",
    addSuccess: "Add success!!",
    addFailed: 'Add Failed!!',
    editorSuccess: "Edit success!!",
    editorFailed: "Editor failed",
    deleteSuccess: "Delete success!!",
    pleaseOnlyOneCondition: "Choose at least one condition!!",
    paramFormatError: "Mandatory items are not filled in. Please revise it and resubmit it",
    deleteFailed: 'Delete failed',
    upSuccess: 'Move up successfully!',
    upFailed: 'Empty segment can not be move up',
    recallSuccess: 'Reset successfully!',
    recallFailed: 'Reset Failed',
    deleteInfo: 'Would you want to delete the file?',
    deleteTranslate: 'Would you want to delete the segment?',
    numberFormatIsError: 'Please input number',
    emailFormatError: 'Please input email',
    notUnique: 'Duplicate account, please input again',
    save: 'Save',
    preview: 'Preview',
    submitAll: 'Submit all',
    back: 'Back',
    view: 'View',
    right: 'Correct',
    fault: 'Error',
    cancelSuccess: 'Cancel successfully',
    sureSuccess: 'Submit successfully',
    hasNo: 'No',
    hasYes: 'Yes',
    of: 'Of',
    idSubmit: "Sumit all",
    isHkOnly: "Make sure you have review the HK only image",
    info: 'Tip',
    upper: 'Previous',
    import: 'Import',
    export: 'Export',
    publish: 'Release',
    publishAll: "Release All",
    createTime: 'Create Time',
    createBy: 'Create By',
    updateTime: 'Update Time',
    updateBy: 'Update By',
    platform: 'Platform',
    type: 'Type',
    pleaseUploadFile: "Please upload file!",
    pleaseChooseFile: "Please choose file!",
    downloadList: 'Download List',
    process: 'Process',
    successProcess: 'Success Process',
    toProcess: 'To Process',
    processFailed: 'Process Failed',
    download: 'Download',
    test: 'Test',
    operationSuccess: "Operation Success！！",
    noData: 'No Data',
    operationFailed: "Operation Failed！！",
    selectDate: 'Select Date',
    upload: 'upload',
    status: 'Status',
    fileUpload: 'File Upload',
    chooseFile: "Choose file",
    uploadSuccess: "Upload Success!",
    publishOk: "Release Success",
    batchImport: "Batch Import",
    insert: "Insert",
    deleteDataInfo: "Are you sure you want to delete this data?",
    replace: 'Replace',
    Yes: 'Yes',
    No: 'No',
    downloadSuccess: "Download Success!",
    downloadFailed: "Download Failed!",
    keyword: 'Keyword',
    completionTimeOfTranslation: 'Completion Time Of Translation',
    reviewTime: 'Review Time',
    uploadFailed: "Upload Failed！",
  },
  menu: {
    scds: "SCDS",
    scdsTaskList: "Asset Deliver Managerment",
    assetConfidentialityManagement: "Asset Confidentiality Management",
    attribution: 'attribution',
    image: 'Image review',
    sizeChart: 'Size chart',
    copyTrackingList: 'Copy tracking list',
    uploadTranslate: 'HK Translation Upload',
    copySample: 'Sample upload',
    uploadAirbag: 'Air cut-open upload',
    copyDistribute: 'CN order management',
    copyDistributeHk: 'HK order management',
    copyTranslate: 'CN copy review',
    copyTranslateHkList: 'HK copy review',
    copyQc: 'CN copy QC',
    copyQcHkList: 'HK copy QC',
    copyTaskList: 'CN copy management',
    copyTaskListHk: 'HK copy management',
    sysUser: 'User management',
    sysRole: 'Role management',
    sysApiRole: 'Product API Role management',
    copy: 'Copy review',
    dictForbidden: 'Forbidden words',
    dictProfessional: 'Professional words',
    system: 'System management',
    imageTrackingList: 'Image tracking list',
    imageErrorLogList: 'Error log sync',
    UpdateImageTL: 'Update Image TL',
    UpdateCopyTL: 'Update Copy TL',
    SysReport: 'Report',
    imageDistribute: 'Order management',
    imageCompare: 'Image review',
    imageQc: 'Image QC',
    imageTaskList: 'Task management',
    copyAirbag: 'Air cut-open upload',
    dictCopyErrorType: 'Copy error type',
    dictImageErrorType: 'Image error type',
    uploadEnCopy: 'HK EN upload',
    sampleDistribute: 'Sample distribute',
    copyDistributeSample: 'Sample distribute',
    masterData: 'Master data',
    sampleUpload: 'Sample upload',
    copyReturn: 'CN copy back',
    startTranslate: 'Start',
    copyCombine: 'TM copy merge',
    copyCombineList: 'TM copy merge',
    productManage: "Image management",
    copyManage: "Copy management",
    readiness: 'Image Readiness',
    copyReadiness: 'Copy Readiness',
    leadTime: "Lead time",
    report: 'Report',
    copyProduct: 'Copy version',
    sysMail: 'Email management',
    SftpUpload: 'Infographic Upload',
    DownloadZip: "Download",
    AssetDownload: "Asset download",
    CopyDownload: "Copy",
    ImageDownload: "Image",
    localImage: "Local image",
    dataImport: "Data import",
    assetReview: "Asset review",
    localImageTaskCreate: "Task create",
    localImageDistribute: "Order management",
    localImageCompare: 'Image review',
    localImageQc: 'Image QC',
    localImageTaskList: 'Task management',
    attributeManagement: 'Attribute Config',
    fitReport: 'Fitting Report',
    trackingList: 'TL List',
    sysOrg: "Organization management",
    assetsUploadList: "Assets Upload",
    sysGlossary: "Translation Glossary",
    sysDisclaimer: "sysDisclaimer",
    sysDict: "Dictionary Management",
    sysApiInfo: "sysApiInfo",
    biRepository: "Bi Repository",
    proofRule: "Proof Rule",
    productKnowledge: "Product Knowledge",
    imageCertificateList: "Certificate Management",
    licenseUpload: "License",
    sellPoint: "Sell Point",
    keyWords: "Attributes & Keywords Upload",
    copyDatabase: "Copy Database",
    laydownMeasurement: "Laydown Measurement",
    labelManagement: "Label Management",
    sizeAndFit: "Size & Fit",
    storeManage: "Store Management",
    errorTicket: "Error Ticket",
    HWTable: "H/W Table",
    fastAsset: "Fast Asset",
    fastDataImport: "Data import",
    fastAssetReview: "Asset review",
    fastDistribute: "Order management",
    fastImageCompare: "Image review",
    fastImageQc: "Image QC",
    fastTaskList: "Task management",
    AGC: "AGC Asset",
    AgcDataImport: "AGC Data import",
    AgcAssetReview: "AGC Asset review",
    AgcOrderManage: "AGC Order management",
    AgcImageCompare: "AGC Image review",
    AgcImageQc: "AGC Image QC",
    AgcTaskList: "AGC Task management",
    colorDescription: "Color Description",
    ruleManagement: "Rule Management",
    launchCalendarCopy: "Launch Calendar Copy",
    pdpImageVideo: "--Global PDP Image/Video--",
    LpdpimageVideo: "--Local PDP Image/Video--",
    pdpCopy: "--Global PDP Copy--",
    knowledgeBase: "--Global Knowledge Base--",
    assetDownload: "--Global Asset Download--",
    publishManage: "--Global Publish Management--",
    epdpCopy: 'EPD Copy',
    epdpListUpload: 'List Upload',
    epdpCopyReview: 'Copy Review',
    epdpCopyQuery: 'Copy Query',
  },
  ruleManagement: {
    divisionInfo: 'DIVISION cannot be empty',
    categoryInfo: 'CATEGORY cannot be empty',
    ageInfo: 'AGE cannot be empty',
    lineInfo: 'LINE cannot be empty',
    keywordInfo: 'KEYWORD cannot be empty',
    shortCircuitInfo: 'SHORT CIRCUIT cannot be empty',
    imageSelect: 'Please select image',
    clickHere: 'Click here',
    pasteImage: 'Press Ctrl+V to paste image',
    fileName: 'File name',
    uploadUser: 'Upload by',
    uploadTime: 'Upload time',
    status: "Status",
    status_0: "Pending",
    status_1: "Processed",
    status_2: "Processing Exception",
    status_3: "Processing",
    actionLineBegin: 'Beginning of paragraph',
    actionLineEnd: 'End of paragraph',
    actionLineEmpty: 'Empty',
    actionLine1Info: 'ACTION LINE 1 cannot be empty',
    positionLine1Info: 'POSITION LINE 1 cannot be empty',
    contentLine1Info: 'CONTENT LINE 1 cannot be empty',
    replaceLine1Info: 'REPLACE LINE 1 cannot be empty',
    actionLine2Info: 'ACTION LINE 2 cannot be empty',
    positionLine2Info: 'POSITION LINE 2 cannot be empty',
    contentLine2Info: 'CONTENT LINE 2 cannot be empty',
    replaceLine2Info: 'REPLACE LINE 2 cannot be empty'
  },
  sysUser: {
    realName: 'Real name',
    password: 'Password',
    gmtModified: 'Modified at',
    orgName: 'Organization',
    phone: 'Phone number',
    isDelete: 'is deleted',
    id: 'ID',
    userName: 'Account name',
    gmtCreate: 'create time',
    email: 'Email',
    lang: 'language',
    lang_en: "en",
    lang_zh: "zh",
    role: 'Role',


    // |||||||||||||
    reset: 'Reset password',
    resetSuccess: 'Reset password successfully',
    deleteInfo: 'Would you want to delete the user?',
    copyTaskInWork: "Can not be delete, the user link to available Copy task",
    imageTaskInWork: "Can not be delete, the user link to available Image task",
    unlock: "Unlock",
    unlockSuccess: "Unlock Success"
    // |||||||||||||

  },
  sysRole: {
    gmtModified: 'Modify date',
    roleCode: 'Role code',
    roleName: 'Role name',
    roleType: 'Role Type',
    roleType_null: '',
    roleType_0: '界面权限',
    roleType_1: '按钮权限',
    roleType_2: '特殊权限',
    roleType_3: '自定义角色',
    parentId: 'parent node',
    sort: 'Position',
    description: 'Description',
    id: 'ID',
    gmtCreate: 'Create date',
    permission: 'Assign',
    assginAuthSucess: 'Provilege assigned successfully',
    deleteInfo: 'Would you want to delete this role?',
  },
  login: {
    forgetPassword: 'Please contact the administrator',
    accountNotExist: 'The account does not exist',
    passowrdIsWrong: 'Password error',
    userLocked: "Password expired. Please change your password",
    passwordExpiration1: "Password expired. Please change your password",
    passwordExpiration: "The password will expire in DayNumber days. Please change your password",
    noAuth: 'The current account does not have permission, please contact the administrator to assign',
    userAuthIsOut: 'User login information expired, please login again',
    changePassword: 'Reset password',
    oldPassword: 'Old password',
    newPassword: 'New password',
    repeatPassword: 'Input again',
    passwordNotNull: 'Password cannot be empty',
    passwordNotEquals: 'Passwords do not match',
    passwordVerifyComplexity: 'Min. 8 letterings/ numbers/ symbols',
    changePasswordSuccess: 'Password reset successfully, you need to log in again',
    emailNotExist: 'Account not bound to email',
    sendEmailError: 'Failed to send verification code. Please try again',
    validCodeNotExist: 'The verification code does not exist, please try again',
    validCodeNotValid: 'The verification code is invalid. Please re apply for the verification code',
    validCodeNotEqual: 'Verification code failed. Please re-enter',
    userNameNotNull: 'The user name cannot be empty',
    validCodeNotNull: 'Verification code cannot be empty',
    sendCodeSuccess: 'The verification code has been sent successfully. Please log in to your email',
    notUser: "You do not have the right to log on to AMT. Please contact the administrator",
  },
  trackingList: {
    startDate: "Start date",
    endDate: "End date",
    listType: "File type",
    all: "All",
    listType_0: "DAM Tracking List",
    listType_1: "LOC Tracking List",
    listType_2: "DAM Campaign List",
    listType_3: "LOC Campaign List",
    listType_4: "ON-Shelf List",
    listType_6: "VHALL ON-Shelf List",
    listType_5: "DML",
    listType_10: "DY DML",
    listType_11: "HW DML",
    listType_12: "QAP List",
    search: "Search",
    reset: "Reset",
    chooseFile: "Choose file",
    loading: "Loading...",
    upload: "Upload",
    uploading: "Uploading...",
    excelName: "File name",
    createUser: "Operator",
    createTeam: "Operator team",
    createTime: "Upload time",
    pleaseChooseFile: "Please choose file!",
    pleaseUploadFile: "Please upload file!",
    uploadSuccess: "Success!",
    uploadSkuList: "Upload SKU list",
    chosseFileType: "Choose File Type!",

    // |||||||||||||||||||||||
    uploadTrackingList: "Upload tracking list",
    uploadCampaignList: "Upload campaign list",
    imageTaskInProcess: 'Image task generation is running at backend , please try later',
    uploadFailed: "Upload failed!",
    updateTask: "Double confirm all the tracking list have be upload",
    uploadAll: "Confirm update all the task?",
    submitSuccess: "Submit successfully, task update is in process!",
    excelIsParsing: "Excel is parsing at backend ,please try later!",
    taskIsRunning: "Task update is running at backend ,please try later!",
    createTask: "Create Task"
    // |||||||||||||||||||||||
  },
  imageErrorLogList: {
    startDate: "Start date",
    endDate: "End date",
    createTime: "Upload date",
    createUser: "Upload by",
    excelName: "File name",
    chooseFile: "Select",
    loading: "Loading...",
    upload: "Upload",
    uploading: "Uploading...",
    uploadImageErrorLogList: "Upload Error Log",
    pleaseChooseFile: "Please select a file!",
    uploadSuccess: "Upload successfully!",

  },
  sampleUpload: {
    id: "ID",
    productCode: "SKU",
    productName: "Product name",
    category: "Category",
    isHkOnly: "HK only",
    hkOnly_0: "No",
    hkOnly_1: "Yes",
    inventoryStatus: 'Inventory',
    existInventory_0: "No",
    existInventory_1: "Yes",
    sampleStatus: 'Sample',
    sampleStatus_0: "No sample",
    sampleStatus_1: "In process",
    sampleStatus_2: "Uploaded",
    sampleStatus_3: "Shipped",
    sampleStatus_4: "Simple Filed",
    prodType: "Product type",
    genderGroup: "Gender",
    productInfoOwner: "OP",
    status: "Status",
    cnLaunchDate: "OMD",
    startDate: "Start date",
    endDate: "End date",
    search: "Search",
    reset: "Reset",
    refresh: "Refresh",
    distribute: "Dispatch",
    recall: "Recall",
    operation: "Operation",
    chooseImage: "Choose image",
    loading: "Loading...",
    upload: "Upload",
    preview: "Preview",
    finish: "Finish",
    uploading: "Uploading...",
    all: "All",
    high: "High",
    medium: "Mid",
    low: "Low",
    compareUser: "Reviewer",
    chooseUser: 'Choose user',
    sampleDistributeUser: 'Process user',
    sampleDistributeTeam: 'Process team',
    sample: "Send request",
  },
  imageEditor: {
    loadImageError: 'Image loading error，can not proceed',
    flagPositionError: 'The mark not correct ,please mark again',
    pleaseSelectFlag: 'The mark only can be deleted under delete model'
  },
  imageSelected: {
    noImage: 'No image',
    selectOnlyOne: 'select atlease on image'
  },
  imageOperation: {
    sku: 'SKU',
    st: 'ST',
    prem: 'PREM',
    rawImage: 'RAW Image',
    refresh: 'Refresh',
    clear: 'Clear',
    selectSample: 'Select sample',
    selectCertificate: 'Select Certificate',
    selectShoeBox: 'Select Shoe Box Label',
    global: 'Global',
    sample: 'Sample',
    change: 'Change',
    imageSelect: 'Select image',
    compareResult: 'Review result',
    resultType: 'Error type',
    resultDescription: 'Error Description',
    imageName: 'Image name',
    direction: 'Direction',
    compareTime: 'Review time',
    compareUser: 'Reviewer',
    qcResult: 'QC result',
    qcTime: 'QC time',
    qcUser: 'QC by',
    qcRemark: 'QC comment',
    resultList: 'Error list',
    finalCopy: 'Final copy',
    compare: 'Review',
    backList: 'Return',
    errNumber: 'NO.',
    all: "All",
    high: "High",
    medium: "Mid",
    low: "Low",
    qc: 'QC',
    startTreate: 'Start precess',
    approveDescription: 'QC comment',
    approveResult: 'QC result',
    approveHistory: 'QC history',
    reject: 'Reject all',
    approve: 'Approve all',
    globalImageType: 'Image type',
    globalImageType_0: 'ST',
    globalImageType_1: 'PREM',
    noChangeHasFlag: 'Delete the marks first before you change sample image',
    notSubmit: 'Detect view not complated, can not submit',
    notChooseCertificate: 'No certificate has been selected, can not submit',
    submitSuccess: 'Submit successfully',
    openImageError: 'Can not open RAW image, loading exceotion or missing sample',
    qcStatus_1: 'Reject',
    qcStatus_0: 'Not complete',
    qcStatus_null: 'Not complete',
    qcStatus_undefined: 'Not complete',
    qcStatus_empty: '',
    qcStatus_2: 'Approved',
    qcStatusHistory_1: 'Rejected',
    qcStatusHistory_0: 'Approved',
    qcStatusHistory_null: 'Approved',
    qcStatusHistory_undefined: 'Approved',
    qcStatusHistory_empty: '',
    qcStatusHistory_2: 'Approved',
    compareStatus_0: 'Not complete',
    compareStatus_1: 'Error',
    compareStatus_2: 'Correct',
    historyVersion: 'History',
    noSample: 'No image selected, can not process',
    compareStatusRight: 'Review result is correct, can not process',
    notChangeCompareResult: 'Detect error marks, can not change the result to correct',
    errorMessageNotNull: 'Error description can not be empty',
    errorTypeNotNull: 'Error description can not be empty',
    onlyOneErrorFlag: 'No error marks',
    flagNumberNotEqual: 'Marks mismatch, please check',
    qcErrorMsgNotNull: 'QC comment can not be empty',
    notQcSubmit: 'Please input the error',
    mustAllApprove: 'All the result must be approve必',
    historyApprove: 'QC history',
    compareStatus_undefined: 'Not reviewd',
    compareDescriptionIsError: "Error description can not be empty:",
    errorTypesIsError: "Error type can not be empty:",
    sampleImageIsNull: "Sample can not be empty:",
    imageNormalCompareIsNull: "Status can not be empty:",
    imageNormalCompareStatusIsError: "Status and restul mismatch:",
    compareErrorIsNotEmpty: "No error information found:",
    errorFlagIsExistEqual: "Error mark not unique:",
    flagIsMustBeExist: "Error mark on RAW/Sample mismatch:",
    flagPositionIsError: "Error mark not available:",
    taskHasCompletedNotOperate: "Task has be completed, can not modify:",
    taskHasSubmitNotOperate: "Task has submited, can not modify:",
    imageShow: 'Show image',
    closeUps: 'Close Ups',
    image: 'Image'
  },
  imagePagination: {
    completed: 'Completed'
  },
  assetDownload: {
    season: "Season",
    gender: "Gender",
    status: "Status",
    download: "Download",
    platform: "Platform",
    format: "Format",
    drawerTitle: "Download bar",
    PackagingFailed: 'Process failed',
    maxChooseImage: "Up limit to 10 SKUs each download",
    maxChooseCopy: "Up limit to 50 Copy each download",
    noChecked: "Please select atleast one reFirst time",
    pleaseSelect: "Please select",
    noAccessed: "No available copy",
    division: 'Division',
    dimension: 'Dimension',
    resolution: 'Resolution',
    fsize: 'File Size/SKU'
  },
  readiness: {
    searchComment: 'Start and end date can not be empty',
    platform: 'PLATFORM',
    contents: 'CONTENTS',
    seasonalTotal: 'SEASONAL TOTAL',
    total: 'Total',
    imageReady: 'Image READY',
    correct: 'CORRECT',
    error: 'ERROR',
    stError: 'ST Error',
    premError: 'PREM Error',
    inProduction: 'IN PRODUCTION',
    noGlobalImages: 'No Global Images',
    noSample: 'No Sample',
    verifying: 'Verifying',
    noSampleImage: 'OUT OF WORK',
  },
  copyReadiness: {
    searchComment: 'Start and end date can not be empty',
    platform: 'PLATFORM',
    contents: 'CONTENTS',
    seasonalTotal: 'SEASONAL TOTAL',
    total: 'Total',
    copyReady: 'Copy READY',
    inProduction: 'IN PRODUCTION',
    lwReviewed: 'LW Reviewed',
    copyWrited: 'Copy Writed',
    lwReviewing: 'LW Reviewing',
    lwCopyWriting: 'LW Copy Writing',
    outOfWork: 'OUT OF WORK',
    noSample: 'Translation Delivered, no Inventory',
    noTranslation: 'Inventory delivered, no Translation',
    noSampleTranslation: 'No Translation, no Inventory',
  },
  imageDistribute: {
    id: "ID",
    productCode: "SKU",
    productName: "Product name",
    category: "Product type",
    imageStatus: 'Image status',
    existGlobalImage_0: "No",
    existGlobalImage_1: "Yes",
    inventoryStatus: 'Inventory',
    existInventory_0: "No",
    existInventory_1: "Yes",
    sampleStatus: 'Sample',
    sampleStatus_0: "No Sample",
    sampleStatus_1: "In process",
    sampleStatus_2: "Uploaded",
    sampleStatus_3: "Shipped",
    sampleStatus_4: "Simple Filed",
    prodType: "Product type",
    genderGroup: "Gender",
    snkrsLaunch: "SNKRS",
    snkrsLaunch_Y: "Yes",
    snkrsLaunch_N: "No",
    snkrsLaunch_: "No",
    taskType: "Type",
    taskType_1: "New",
    taskType_2: "Overdue",
    taskStatus: "Status",
    distributeStatus: "Status",
    taskStatus_0: "Pending dispatch",
    taskStatus_1: "Pending receive",
    taskStatus_2: "In review",
    taskStatus_3: "In QC",
    taskStatus_4: "Complete",
    cnLaunchDate: "OMD",
    startDate: "Start date",
    endDate: "End date",
    priorityLevel: "Priority",
    priorityLevel_0: "Initial",
    priorityLevel_1: "Low",
    priorityLevel_2: "Mid",
    priorityLevel_3: "High",
    priorityLevel_4: "Urgent",
    search: "Search",
    reset: "Reset",
    refresh: "Refresh",
    distribute: "Dispatch",
    recall: "Recall",
    operation: "Operation",
    all: "All",
    compareUser: "Reviewer",
    taskTimes: "Review times",
    chooseUser: 'Choose user',
    isCampaign: 'Campaign',
    isCampaign_null: 'No',
    isCampaign_0: 'No',
    isCampaign_1: 'Yes',
    certificate: 'certificate',
    dueDate: 'DueDate'
  },
  imageTaskList: {
    id: "ID",
    productCode: "SKU",
    productName: "Product name",
    category: "Product type",
    imageStatus: 'Image status',
    existGlobalImage_0: "No",
    existGlobalImage_1: "Yes",
    inventoryStatus: 'Inventory',
    existInventory_null: "No",
    existInventory_0: "No",
    existInventory_1: "Yes",
    sampleStatus: 'Sample',
    sampleStatus_null: "No Sample",
    sampleStatus_0: "No Sample",
    sampleStatus_1: "In process",
    sampleStatus_2: "Uploaded",
    sampleStatus_3: "Shipped",
    sampleStatus_4: "Simple Filed",
    prodType: "Product type",
    genderGroup: "Gender",
    snkrsLaunch: "SNKRS",
    snkrsLaunch_Y: "Yes",
    snkrsLaunch_N: "No",
    distributeStatus: "Status",
    taskType: "Type",
    taskType_null: "",
    taskType_1: "New",
    taskType_2: "Overdue",
    taskStatus: "Status",
    taskStatus_0: "Pending dispatch",
    taskStatus_1: "Pending receive",
    taskStatus_2: "In review",
    taskStatus_3: "In QC",
    taskStatus_4: "Complete",
    qcUser: 'QC userr',
    qcResult: 'QC result',
    qcResult_0: 'Pending QC',
    qcResult_1: 'Reject',
    qcResult_2: 'Approve',
    qcStatus: "QC result",
    qcStatus_0: "Pending QC",
    qcStatus_1: "Reject",
    qcStatus_2: "Approve",
    isDelete: "Order status",
    isDelete_0: "Active",
    isDelete_1: "Close",
    damStatus: "Reopen",
    damStatus_0: "No",
    damStatus_1: "Yes",
    isCampaign: "Campaign",
    isCampaign_0: "No",
    isCampaign_1: "Yes",
    cnLaunchDate: "OMD",
    startDate: "Start date",
    endDate: "End date",
    priorityLevel: "Priority",
    priorityLevel_0: "Initial",
    priorityLevel_1: "Low",
    priorityLevel_2: "Mid",
    priorityLevel_3: "High",
    priorityLevel_4: "Urgent",
    search: "Search",
    reset: "Reset",
    refresh: "Refresh",
    distribute: "Dispatch",
    recall: "Recall",
    operation: "Operation",
    all: "All",
    compareUser: "Reviewer",
    taskTimes: "Review times",
    reOpen: "Reopen",
    imageTaskDetail: "Task Detail",
    reOpenDescription: "Reopen reason",
    recheck: 'Reopen',
    memberShip: 'MEMBERSHIP OFFER DATE',
    isPremStatus: 'PREM',
    isPremError_0: 'Correct',
    isPremError_1: 'Error',
    isStStatus: 'ST',
    isStError_0: 'Correct',
    isStError_1: 'Error',
    qcTime: 'QC time',
    certificate: 'certificate',
    organization: 'organization',
    urgent: 'Urgent',
    cancelUrgent: 'Cancel Urgent',
    urgentDate: 'Urgent Date',
    dueDate: 'Due Date',
    isUrgent: 'Is urgent',
    isUrgent_0: 'No',
    isUrgent_1: 'Yes',
    isUrgent_null: 'No',
    sampleDistributeTime: "Sample/Dispatch Date",
    isHideImage: 'Hide status',
    pendingType: "pending原因",
    pendingType_0: "No",
    pendingType_1: "Cut-open",
    pendingType_2: "Pending Waterproof Report",
    pendingType_3: "Pending Sample",
    pendingType_4: "Pending Regrown Material Report",
    pendingType_5: "Pending Sunscreen Report",
  },
  copyTaskList: {
    id: "ID",
    productCode: "SKU",
    style: "STYLE",
    productName: "Product name",
    category: "Product type",
    enCopyStatus: 'Status',
    zhCopyStatus: 'ZH Status',
    imageStatus: 'Image status',
    existGlobalImage_0: "No",
    existGlobalImage_1: "Yes",
    productInfoOwner: "OP",
    compareUser: "Reviewer",
    status: "Order status",
    omd: "OMD",
    cnLaunchDate: "Release date",
    hkLaunchDate: "HKRelease date",
    prodType: "Product type",
    chooseImage: "Select",
    loading: "Loading...",
    upload: "Upload",
    uploading: "UploadMid...",
    isFirst: 'First time',
    inventoryStatus: 'Inventory',
    existInventory_0: "No",
    existInventory_1: "Yes",
    sampleStatus: 'Sample',
    sampleStatus_0: "No Sample",
    sampleStatus_1: "In process",
    sampleStatus_2: "Uploaded",
    sampleStatus_3: "Shipped",
    sampleStatus_4: "Simple Filed",
    platformType: "Platform",
    platformType_0: "CN",
    platformType_1: "HK",
    platformType_2: 'TMALL',
    platformType_3: 'CN & TMALL',
    needAirbag: "Need Cut-open",
    needAirbag_0: "No",
    needAirbag_1: "Yes",
    airbagStatus: "Cut-open",
    airbagStatus_0: "No",
    airbagStatus_1: "Yes",
    writingStatus: "COPY WRITING",
    writingStatus_0: "No",
    writingStatus_1: "Yes",
    existTranslate: "Translation",
    existTranslate_0: "No",
    existTranslate_1: "Yes",
    genderGroup: "Gender",
    snkrsLaunch: "SNKRS",
    snkrsLaunch_Y: "Yes",
    snkrsLaunch_N: "No",
    startDate: "Start date",
    endDate: "End date",
    priorityLevel: "Priority",
    priorityLevel_0: "Initial",
    priorityLevel_1: "Low",
    priorityLevel_2: "Mid",
    priorityLevel_3: "High",
    priorityLevel_4: "Urgent",
    taskStatus: "Status",
    taskStatus_0: "Pending",
    taskStatus_1: "Not receive",
    taskStatus_2: "In review",
    taskStatus_3: "In QC",
    taskStatus_4: "Complete",
    qcResult: 'QC result',
    qcResult_0: 'Not complete',
    qcResult_1: 'Reject',
    qcResult_2: 'Approve',
    damStatus: "Reopen",
    damStatus_0: "No",
    damStatus_1: "Yes",
    isCampaign: "Campaign",
    isCampaign_0: "No",
    isCampaign_1: "Yes",
    search: "Search",
    reset: "Reset",
    refresh: "Refresh",
    distribute: "Dispatch",
    recall: "Recall",
    operation: "Operation",
    all: "All",
    translateUser: "Reviewer",
    translateTime: "Review time",
    qcUser: "QC by",
    qcTime: "QC time",
    reOpenDescription: "Reopen reason",
    startDate2: "Translate date",
    lingotekOrOffline: "Translation from",
    lingotekOrOffline_0: "Lingotek",
    lingotekOrOffline_1: "Offline",
    lingotekOrOffline_2: "No",
    lingotekOrOffline_3: "Phrase",
    recallMessage: "Task recalled, can not review",
    cancelMessage: "Task canceled , can not review",
    taskType2: "Translation from",
    taskType2_0: "Translation",
    taskType2_1: "Copywriting",
    lastUpdated: "Translation date",
    pendingType: "pending原因",
    pendingType_0: "No",
    pendingType_1: "Cut-open",
    pendingType_2: "Pending Waterproof Report",
    pendingType_3: "Pending Sample",
    pendingType_4: "Pending Regrown Material Report",
    pendingType_5: "Pending Sunscreen Report",
    taskType: "Task type",
    taskType_null: "",
    taskType_0: "NEW",
    taskType_1: "UPDATE",
    taskType_2: "OVERDUE",
    specialCase: "KEY",
    campaign: "Campaign",
    reject: "Reject",
    reOpen: "REDO",
    sizingFit: "TranslationType",
    sizingFit_0: "PDP",
    sizingFit_1: "S&F",
    publishError: "Release failed, please try later",
    publishOk: "Release successfully",
    reOpenTask: "Reopen",
    copyTaskDetail: "Details",
    organization: 'organization',
    urgent: 'Urgent',
    cancelUrgent: 'Cancel Urgent',
    urgentDate: 'Urgent Date',
    dueDate: 'Due Date',
    isUrgent: 'Is urgent',
    isUrgent_0: 'No',
    isUrgent_1: 'Yes',
    isUrgent_null: 'No'
  },
  dictForbidden: {
    gmtModified: "Modify date",
    forbiddenWord: "Forbidden words",
    remark: "Remark",
    id: "",
    gmtCreate: "Create date",
    platformType: 'Platform',
    platformType_0: 'CN',
    platformType_1: 'HK',
  },
  dictProfessional: {
    gmtModified: "Modify date",
    isDelete: "",
    professionalWord: "Professional words",
    remark: "Remark",
    id: "",
    professionalTranslate: "Translation",
    gmtCreate: "Create date",
    platformType: 'Platform',
    platformType_0: 'CN',
    platformType_1: 'HK',
  },
  copyAirbag: {
    season: "Season",
    category: "Product type",
    style: "STYLE",
    styleName: "Style name",
    sku: "SKU",
    existAirbag: "Status",
    existAirbag_Y: "Yes",
    existAirbag_N: "No",
    airbagQty: "Air Qty",
    insole: "In sole",
    forefoot: "Fore foot",
    hell: "Hell",
    fullLength: "Full length",
    airbagType: "Airbag Type",
    fullLengthCarbon: "Full Length Carbon",
    plasticBoard: "Plastic Board",
    airbagStatus: "Cut-open",
    airbagStatus_0: "No",
    airbagStatus_1: "Yes",
    airbagDate: "Air cut date",
    chooseAirbagAllFile: "Air cut-open list",
    chooseAirbagInfoFile: "Air cut-open Info",
    AirbagAllFile:"cut-open list",
    AirbagInfoFile:"cut-open Info",
    productCode: "SKU",
    productName: "Product name",
    download: "Download",
    prodType: "Product type",
    status: "Order status",
    cnLaunchDate: "Release date",
    hkLaunchDate: "HKRelease date",
    startDate: "Start date",
    endDate: "End date",
    search: "Search",
    reset: "Reset",
    refresh: "Refresh",
    operation: "Operation",
    chooseImage: "Select",
    loading: "Loading...",
    upload: "Upload",
    uploading: "Uploading...",
    all: "All",
    fileType:"File Type",
    chooseFile:"Choose File",
    uploadSuccess: "Upload Success",
    uploadFailed: "Upload Failed",
  },
  StyleAvailableRecycled: {
    season: 'Season',
    style: 'STYLE',
    division: 'Division',
    productName: 'Product Name',
    productTable: 'Product Table',
    recycled: 'Recycled',
    comments: ' Comments',
    functions:'Function',
    protectionLevel:'Protection Level',
    testingResult:'Testing Result',
    sourceReport:'Source Of Report',
    confirmDate:'Report Confirm Date',
  },
  contrastTranslation: {
    copyType: "Type",
    rangeOfApplication: 'Range of application',
    qcRemark: 'QC comment',
    professionalWordCheck: "Professional works check",
    forbiddenWordCheck: "Forbidden workds check",
    backList: "Return",
    yes: "Detected Air",
    source: "Source",
    linguistiscReview: "Linguistic Review",
    sepcReview: "Spec Review",
    segmentOrder: "NO.",
    translation: "Translation",
    comment: "Remark",
    translateProblems: "Translation Issue",
    takeSample: "Sample",
    professionalWordResult: "Professinal words",
    forbiddenWordResult: "Forbidden words",
    allSubmitted: "Submit all",
    specialCase: "G->K",
    rejected: "Reject",
    no: "NO.",
    version: "Version",
    translateTime: "Modify date",
    translateUser: "Modified by",
    qcTime: "QC time",
    qcUser: "QC by",
    qcStatus: "QC result",
    updateTime: "Modify date",
    modifier: "Modified by",
    qualityTime: "QC time",
    qualityPeople: "QC by",
    operate: "Operation",
    view: "View",
    qualityResults: "QC result",
    through: "Approve",
    notThrough: "Reject",
    chooseImg: "Select",
    viewImg: "View image",
    airbagDate: "Air cut date",
    category: "Category",
    styleName: "Style name",
    airbagStatus: "Cut-open",
    airbagStatus_0: "No",
    airbagStatus_1: "Yes",
    existAirbag: "Status",
    existAirbag_Y: "Yes",
    existAirbag_N: "No",
    airbagQty: "Air Qty",
    insole: "In sole",
    forefoot: "Fore foot",
    hell: "Hell",
    fullLength: "Full length",
    airbagType: "Airbag Type",
    addDisclaimer: "Add Disclaimer",
    addSegment: "Add segment",
    addBlankSegment: "Add empty segment",
    gmtCreate: "Create date",
    cnCopyDelivered: "Review time",
    finalReview: "Final review",
    gmtModified: "Review complete time",
    taskByStyle: "Task",
    taskByStyle_0: "BY STYLE",
    taskByStyle_1: "BY SKU",
    sizingFit: "SIZE&FIT",
    sizingFit_0: "不Yes",
    sizingFit_1: "Yes",
    qcStatus_1: "Reject",
    qcStatus_2: "Approve",
    comments: "Remark",
    rejectComment: "Please input QC result and reject reason",
    hkRejectComment: "Please input reject reason",
    submitComment: "Existing no approved segment",
    rejectCommentFailed: "Reject failed, please re-trigger",
    segmentInfo: "Pease select segment or insert empty segment",
    finalVersion: "Correct version",
    historyVersion: "History",
    viewQcDescription: "Reject history",
    qcDescription: "Reject reason",
    deliverDate: 'Release date',
    deliverStatus: 'Release status',
    deliverStatus_0: 'Pending release',
    deliverStatus_1: 'Released',
    deliverStatus_2: 'Skip',
    createUser: 'Create by',
    reviewDate: "review 时间",
    recallTranslate: 'Recover deleted segment?',
    noVersion: 'Skip',
    pending: "Pending",
    choosePendingReason: "Pending reason",
    pendingType_0: "No",
    pendingType_1: "Cut-open",
    pendingType_2: "WTP Report",
    pendingType_3: "Sample",
    pendingType_4: "Pending Regrown Material Report",
    pendingType_5: "Pending Sunscreen Report",
    versionDiff: "Difference",
    hisVersion: "Previous version",
    currentVersion: "Current version",
    versionInfo: "Version"
  },
  contrastTranslationHk: {
    global_en: "Global EN",
    translate: "Translate HKTC",
    sepc_review_en: "Spec Review EN",
    sepc_review_hktc: "Spec Review HKTC",
    line1: "LINE1",
    line2: "LINE2",
    long: "LONG",
    desc: "DESC",
    description: "LONG DESC",
    display_name: "Display Name",
  },
  copyDistribute: {
    id: "ID",
    productCode: "SKU",
    style: "STYLE",
    productName: "Product name",
    category: "Product type",
    enCopyStatus: "EN Status",
    zhCopyStatus: "ZH Status",
    imageStatus: "Image status",
    existGlobalImage_0: "No",
    existGlobalImage_1: "Yes",
    productInfoOwner: "OP",
    compareUser: "Reviewer",
    status: "Order status",
    omd: "OMD",
    age: "AGE",
    cnLaunchDate: "Release date",
    hkLaunchDate: "HKRelease date",
    prodType: "Product type",
    chooseImage: "Select",
    loading: "Loading...",
    upload: "Upload",
    uploading: "Uploading...",
    isFirst: "First time",
    inventoryStatus: "Inventory",
    existInventory_0: "No",
    existInventory_1: "Yes",
    sampleStatus: "Sample",
    sampleStatus_0: "No Sample",
    sampleStatus_1: "In process",
    sampleStatus_2: "Uploaded",
    sampleStatus_3: "Shipped",
    sampleStatus_4: "Simple Filed",
    platformType: "Platform",
    platformType_0: "CN",
    platformType_1: "HK",
    platformType_2: 'TMALL',
    platformType_3: 'CN & TMALL',
    needAirbag: "Need Cut-open",
    needAirbag_0: "No",
    needAirbag_1: "Yes",
    airbagStatus: "Cut-open",
    airbagStatus_0: "No",
    airbagStatus_1: "Yes",
    writingStatus: "Copy writing",
    writingStatus_0: "No",
    writingStatus_1: "Yes",
    existTranslate: "Translation",
    existTranslate_0: "No",
    existTranslate_1: "Yes",
    isCampaign: "Campaign",
    isCampaign_0: "No",
    isCampaign_1: "Yes",
    genderGroup: "Gender",
    snkrsLaunch: "SNKRS",
    snkrsLaunch_Y: "Yes",
    snkrsLaunch_N: "No",
    taskStatus: "Status",
    taskStatus_0: "Pending",
    taskStatus_1: "Not receive",
    taskStatus_2: "In review",
    taskStatus_3: "In QC",
    taskStatus_4: "Complete",
    taskStatus2: "Status",
    taskStatus2_0: "Pending",
    taskStatus2_1: "Pending dispatch",
    taskStatus2_2: "Not receive",
    taskStatus2_3: "Received",
    startDate: "Start date",
    endDate: "End date",
    priorityLevel: "Priority",
    priorityLevel_0: "Initial",
    priorityLevel_1: "Low",
    priorityLevel_2: "Mid",
    priorityLevel_3: "High",
    priorityLevel_4: "Urgent",
    search: "Search",
    reset: "Reset",
    refresh: "Refresh",
    distribute: "Dispatch",
    distribute2: "Review dispatch",
    writingStatus2: "Cope writing dispatch",
    recall: "Recall",
    forward: "Forward",
    forward2: "Review forward",
    forward3: "Copy writing forward",
    operation: "Operation",
    daifenfa: "Pending dispatch",
    daijieshou: "Pending receive",
    high: "High",
    medium: "Mid",
    low: "Low",
    all: "All",
    translateUser: "Reviewer",
    taskTimes: "Review times",
    chooseUser: "Choose user",
    startDate2: "Translate date",
    lingotekOrOffline: "Translation from",
    lingotekOrOffline_0: "Lingotek",
    lingotekOrOffline_1: "Offline",
    lingotekOrOffline_2: "No",
    lingotekOrOffline_3: "Phrase",
    taskType2: "Translation from",
    taskType2_0: "Translation",
    taskType2_1: "Copywriting",
    lastUpdated: "Translation date",
    campaign: "Campaign",
    reject: "Reject",
    specialCase: "KEY",
    reOpen: "REDO",
    taskType: "Task type",
    taskType_0: "NEW",
    taskType_1: "UPDATE",
    taskType_2: "OVERDUE",
    sizingFit: "TranslationType",
    sizingFit_0: "PDP",
    sizingFit_1: "S&F",
    downCopy: "Download copy",
    finishedStyleCount: "Completed",
    styleCount: "Not completed(Style)",
    skuCount: "Not completed(Style)"
  },
  dictCopyErrorType: {
    gmtModified: "Modify date",
    errorType: "ErrorType",
    isDelete: "",
    remark: "Remark",
    id: "",
    gmtCreate: "Create date",
    attribution: 'Attribution',
    defectCategory: 'Error category',
    headline: 'Title',
    instruction: 'Remark',
    nonEnError: 'NoFirst timeError',
    enError: 'First timeError',
    deduction: 'Deduction',
    platformType: 'Platform',
    platformType_0: 'CN',
    platformType_1: 'HK'
  },
  dictImageErrorType: {
    gmtModified: "Modify date",
    errorType: "ErrorType",
    isDelete: "",
    remark: "Remark",
    id: "",
    gmtCreate: "Create date"
  },
  copyUpload: {
    uploadDate: "Upload date",
    translateCreateDate: "First time date",
    translateOverDate: "Translation date",
    code: "STYLE/SKU",
    isStyle: "Type",
    isStyle_0: "STYLE",
    isStyle_1: "SKU",
    line1: "LINE1",
    line2: "LINE2",
    line2Zh: "line2 translation",
    startDate: "Start date",
    endDate: "End date",
    search: "Search",
    reset: "Reset",
    chooseFile: "Select",
    loading: "Loading...",
    upload: "Upload",
    uploading: "Uploading...",
    excelName: "File name",
    createUser: "Upload by",
    createTime: "Upload time",
    translateUser: "Reviewer",
    distribute: "Dispatch",
    distributing: "DispatchMid...",
    distributeStatus: "Status",
    all: "All",
    distributeStatus_0: "Pending",
    distributeStatus_1: "Complete",
    distributeTime: "Dispatch time",
    operation: "Operation",
    pleaseChooseFile: "Select!",
    uploadSuccess: "Upload successfully!",
    download: "Download",
    uploadEN: "UploadEN",
    uploadHKTC: "UploadHKTC",
    chooseUser: 'Choose user',
    status: "Status",
    status_0: "Pending",
    status_1: "Completed",
    enStatus_0: "Pending",
    enStatus_1: "Processing",
    enStatus_2: "Completed",
    enStatus_3: "Fail",
  },
  copyTranslate: {
    startTreate: "Process",
    translate: "Review",
    startTranslate: "Process",
    writing: "Copy writing",
    translateUpdate: "Update copy"
  },
  copyQc: {
    qc: "QC",
    backList: "Return"
  },
  sampleDistribute: {
    id: "ID",
    listType: "Order type",
    productCode: "SKU",
    productName: "Product name",
    category: "Product type",
    genderGroup: "Gender",
    isHkOnly: "YesNoHK Only",
    hkOnly_0: "No",
    hkOnly_1: "Yes",
    inventoryStatus: "Inventory",
    existInventory_0: "No",
    existInventory_1: "Yes",
    sampleStatus: "Sample",
    sampleStatus_0: "No Sample",
    sampleStatus_1: "In process",
    sampleStatus_2: "Uploaded",
    sampleStatus_3: "Shipped",
    sampleStatus_4: "Simple Filed",
    prodType: "Product type",
    productInfoOwner: "OP",
    status: "Order status",
    cnLaunchDate: "OMD",
    startDate: "Start date",
    endDate: "End date",
    search: "Search",
    reset: "Reset",
    refresh: "Refresh",
    distribute: "Dispatch",
    recall: "Recall",
    operation: "Operation",
    chooseImage: "Select",
    loading: "Loading...",
    upload: "Upload",
    uploading: "Uploading...",
    all: "All",
    high: "High",
    medium: "Mid",
    low: "Low",
    compareUser: "Reviewer",
    chooseUser: "Choose user",
    sampleDistributeUser: "Send by",
    sampleDistributeTeam: "Send by",
    sampleDistributeTime: "Sample send time",
    sampleUploadTime: "Sample upload time",
    sample: "Send",
    sampleLoading: "In process...",
    fileName: "File Name",
    shippingList: "Shipping List",
    uploadResult: "Upload Result",
    uploadResult_0: 'pending',
    uploadResult_1: 'being processed',
    uploadResult_2: 'accomplish',
    uploadResult_3: 'error',
    createUser: 'Create User',
    createTime: 'Create Time',
    sampleDispatchTime: 'Sample/Dispatch Time',
    selectSampleDispatchTime: 'Please select sample dispatch time'
  },
  copyReturn: {
    code: 'STYLE/SKU',
    downloadTime: 'Download time',
    startDate: "Start date",
    endDate: "End time",
    uploadStatus: 'Status',
    all: 'All',
    uploadStatus_0: '可Call back',
    uploadStatus_1: '已Call back',
    taskStatus: "Status",
    taskStatus_0: "Pending",
    taskStatus_1: "Not receive",
    taskStatus_2: "In review",
    taskStatus_3: "In QC",
    taskStatus_4: "Complete",
    qcTime: "QC time",
    isStyle: "Task type",
    isStyle_0: "STYLE",
    isStyle_1: "SKU",
    operation: "Operation",
    return: 'Call back',
    reOpen: 'Call back again',
    productCode: "SKU",
    productName: "Product name",
    category: "Product type",
    prodType: "Product type",
    genderGroup: "Gender",
    omd: "OMD",
    outputByStyle: "Output by",
    outputByStyle_0: "STYLE",
    outputByStyle_1: "SKU",
    linguisticCopy: "Linguistic Review",
    specCopy: "Spec Review",
    finalCopy: "Final Review",
    setReturnTime: "Set Return Time"
  },
  productManage: {
    id: "ID",
    listType: "Order type",
    productCode: "SKU",
    productName: "Product name",
    category: "Product type",
    genderGroup: "Gender",
    inventoryStatus: "Inventory",
    existInventory_0: "No",
    existInventory_1: "Yes",
    sampleStatus: "Sample",
    existGlobalImage: 'Image status',
    existGlobalImage_0: 'No',
    existGlobalImage_null: 'No',
    existGlobalImage_1: 'Yes',
    isHideImage: 'Hide status',
    isHideImage_0: 'No',
    isHideImage_null: 'No',
    isHideImage_1: 'Yes',
    isDeliverImage: 'Status',
    isDeliverImage_0: 'Not completed',
    isDeliverImage_null: 'Not completed',
    isDeliverImage_1: 'Complete',
    sampleStatus_0: "No Sample",
    sampleStatus_1: "In process",
    sampleStatus_2: "Uploaded",
    sampleStatus_3: "Shipped",
    sampleStatus_4: "Simple Filed",
    prodType: "Product type",
    status: "Order status",
    cnLaunchDate: "OMD",
    startDate: "Start date",
    endDate: "End date",
    search: "Search",
    reset: "Reset",
    operation: "Operation",
    all: "All",
    sampleImage: "Sample",
    globalImage: "Global Image",
    CNCopyInfo: "CN COPY",
    HKCopyInfo: "HK COPY",
    copyInfo: "Copy content",
    source: "Source",
    finalReview: "Translation",
    line2Zh: "line2 translation",
    hkDescription: "HKTranslation",
    isStError: 'ST',
    stView: 'ST review result',
    premView: 'PREM review result',
    hiddenStatus: 'Hidden Status',
    isHide: 'Is Hide',
    confidentialFlag: 'Confidential Flag',
    confidentialDate: 'Confidential Date',
    userName: 'Verifier',
    orgName: 'Audit Team',
    isPremError: 'PREM',
    isStError_null: '--',
    isStError_0: 'Correct',
    isStError_1: 'Error',
    isPremError_null: '--',
    isPremError_0: 'Correct',
    isPremError_1: 'Error',
    qcTime: 'QC time',
    memberShip: 'MEMBERSHIP OFFER DATE',
    snkrsLaunch_null: '',
    snkrsLaunch_Y: "Yes",
    snkrsLaunch_N: "No",
    simpleDate: "Simple/Dispatch Date",
    imageStatus: "Image Status",
    imageUploadDate: "BZ Image Upload Date",
    globalImageStatus: "Global Image Status",
    release: 'Release Detail',
    bzSimpleDate: "BZ Sample Date",
    rawImage: 'rawImage',
    omd: "OMD",
    ST: "ST",
    PREM: "PREM",
    folderBatchNo: 'Batch',
    exportRelease: 'Export Release',
    releaseTime: "Release Time",
    bzImageStatus: "BZ Image Status",
    bzImageStatus_0: 'No',
    bzImageStatus_null: 'No',
    bzImageStatus_1: 'Yes',
    imageErrorDescription: 'Image Error Description'
  },
  copyCombine: {
    startDate: "Start date",
    endDate: "End date",
    productCode: "SKU",
    productName: "Product name",
    category: "Product type",
    genderGroup: "Gender",
    prodType: "Product type",
    omd: "OMD",
    operation: "Operation",
    newCopy: 'Lates version',
    submitAll: "Submit all",
    combineSuccess: "Merge successfully!",
    combine: 'Merge',
    combineStatus: 'Status',
    combineTime: 'Merge time',
    style: 'STYLE',
    outputLevel: "Output by",
    outputByStyle_0: "STYLE",
    outputByStyle_1: "SKU",
    combineStatus_0: "Pending merge",
    combineStatus_1: "In process",
    combineStatus_2: "Merged",
    combineStatus_3: "No need merge",
    needCombine: "Need merge",
    submitStatus: "Status",
    all: "All",
    submitStatus_0: "Pending Merge",
    submitStatus_1: "Merged",
    submitStatus_2: "No need merge",
    linguisticCopy: "Linguistic review",
    specCopy: "Spec review",
    finalCopy: "Final review",
    versionInfo: "Version",
    notCombineCanNotSubmit: "Detecte un-merged copy, please process!",
    thisVersion: "Operate by ：",
    combineGet: "Completed!",
    source: "Source",
    translation: "Translation",
    taskFinalCopy: "Final Review",
    currentVersion: "Current version",
    editVersion: "In Merge",
    backList: "Return Task List",
    copy: "Copy",
    edit: "Edit",
    save: "Save",
    startCombine: "Merge",
    unCombine: "No need merge",
    gmtCreate: "Create date",
    sourceTaskStartDate: "Translate date",
    translateUserList: "Reviewers",
    combineUser: "Merge by"
  },
  copyProduct: {
    code: 'STYLE/SKU',
    platformType: 'Platform',
    deliverDate: 'Release date',
    deliverStatus: 'Release status',
    deliverStatus_0: 'Not release',
    deliverStatus_1: 'Released',
  },
  sysMail: {
    gmtModified: 'Modify date',
    type: 'Email type',
    toMails: 'Email TO',
    ccMails: 'Email CC',
    bccMails: 'Email BCC',
    gmtCreate: 'Create date',
    deleteInfo: 'Would you want to delete the role?'
  },
  sysReport: {
    chooseReport: "Report name",
    chooseDate: "Report date",
    reportName: "Report name",
    reportNum: "Report name",
    startTime: "Repot time",
    endTime: "End time",
    gmtCreate: "Trigger time",
    sendType: "Trigger type",
    sendType_0: "System",
    sendType_1: "Manual",
    sendStatus: "Status",
    download: "Download",
    sendUser: "Trigger by",
    status: "Status",
    status_0: "Success",
    status_1: "Error",
    status_2: "No data",
    status_3: "No tracking list",
    startSend: "In process",
    reportTime: "Report date",
    sendAll: "Send today's reports",
    sender: "Receiver"
  },
  manualTrackingList: {
    export: "Export",
    expiredTime: "Effective time",
    gmtCreate: "Upload time"
  },
  sftpUpload: {
    season: "SEASON",
    SKU: "SKU",
    ST: "ST",
    PREM: "PREM",
    st_0: "",
    st_1: "Uploaded",
    st_2: "No image",
    st_3: "Skip",
    st_4: "In review",
    prem_0: "",
    prem_1: "Uploaded",
    prem_2: "No image",
    prem_3: "Skip",
    prem_4: "In review",
    uploadTime: "Upload time",
    download: "Download",
    status: "STATUS",
    status_0: "PENDING",
    status_1: "SUCCESS",
    infographic: "INFOGRAPHIC"
  },
  sizeChart: {
    season: 'Season',
    isMissing: 'Missing',
    version: "Version",
    upload: "Upload",
    download: "Download",
    edit: "Edit",
    save: "Save",
    dispose: "Dispose",
    acceptAll: "Accept all",
    saveSuccess: "save success",
    cannotChange: 'Published, cannot change',
    uploadSuccess: 'uploadSuccess',
    uploadFailure: 'uploadFailure',
    refuseEnter: 'You are not allowed to enter the review interfacRe in this way',
    platform: 'Platform',
    SizeChart: 'Size Chart',
    SKUSizeChart: 'SKU & Size Chart',
    StyleSKU: 'Style/SKU',
    review: 'review',
    sync: 'sync',
    releaseNow: 'Release now',
    SpecifyDate: 'Specify a date to release',
    releaseToday: 'Release on the same day',
    release: 'Release',
    tobeReview: 'Changes To Be Review',
    sizeChartName: 'Name',
    headKey: "head key",
    headName: "head name",
    isBizPk: "is bizpk",
    isHide: "is hide",
    sizeChartCodeName: 'Code Name',
    enableFlag_null: 'Disable',
    enableFlag_0: 'Enable',
    enableFlag_1: 'Disable',
    sizeChartCode: 'Size Chart Code',
    sizeChartNameEn: 'Size Chart Name En',
    sizeChartNameCn: 'Size Chart Name Cn',
    sizeChartNameTc: 'Size Chart Name Tc',
    productType: 'Product Type',
    sizeChartUrl: 'Size Chart Url',
    enableLable: 'Crawl Lable',
    enableLableTc: 'Crawl Lable Tc',
    titlePosition: 'Title Position',
    sizeChartPosition: 'Size Chart Position',
    parentSizeChartCode: 'Parent Size Chart',
    enableFlag: 'Crawl Flag',
  },
  localImage: {
    taskType: "Task type",
    assetsType: "Assets type",
    season: "Season",
    platform: "Platform",
    code: "Style/SKU",
    image: "Image",
    video: "Video",
    shootingMethod: "Shooting method",
    imageName: "image name",
    dimension: "Dimension",
    review: "Review",
    createBy: "Creator",
    createTime: "Create time",
    startDate: "Start date",
    endDate: "End date",
    createTask: "Create task",
    source: "Source",
    createTask_0: "BOX",
    createTask_1: "Upload",
    createTask_2: "Sftp",
    fileName: "File name",
    uploader: "Uploader",
    uploadTime: "UploadTime",
    chooseFile: "Choose file",
    uploading: "Uploading",
    upload: "Upload",
    pleaseChooseFile: "Please choose file!",
    pleaseUploadFile: "Please upload file!",
    pleaseInputFilePath: "Please input file path!",
    uploadSuccess: "Upload succeeded",
    biComparison: "Bi comparison",
    biComparison_1: "BI Comparison",
    biComparison_0: "Review",
    processingProgress: 'Processing progress',
    processingProgress_0: 'Pending',
    processingProgress_1: 'Processing',
    processingProgress_2: 'Success',
    processingProgress_3: 'Fail',
    processingProgress_4: 'Exception',
    sku_level_upload_progress: 'SKU LEVEL UPLOAD PROGRESS',
    cn_release_progress: 'CN RELEASE PROGRESS',
    tmall_release_progress: 'TMALL RELEASE PROGRESS',
    processingDetail: 'Processing detail',
    uploadFile: 'Upload File',
    processingDetailView: 'See',
    folderBatchNo: 'Batch',
    boxLink: "BOX Link",
    uploadDes: "Upload",
    filePath: "File Path",
    seasonErr: "Season cannot be blank",
    boxLinkErr: "boxlink cannot be blank",
    modelEffectiveDaysErr: "model effective days cannot be blank",
    submitCreateTaskSuccess: "Task create success",
    successProcessingNum: "Number of successfully processed",
    failProcessingList: "Exception handling list",
    path: "Path",
    state: "State",
    aiState: "AI State",
    reason: "Reason",
    exception_0: "Success",
    exception_1: "Skip",
    exception_2: "Exception",
    all: "All",
    review_status_0: "To be reviewed",
    review_status_1: "Passed",
    review_status_2: "Refused",
    review_status_3: "Updated",
    review_status_4: "Released",
    aiReview_status_0: "No audit required",
    aiReview_status_1: "To be reviewed",
    aiReview_status_2: "Passed",
    aiReview_status_3: "Refused",
    importTime: "Import time",
    operate: "Operate",
    pass: "Pass",
    refuse: "Refuse",
    wrongAnnotation: "Wrong Annotation",
    opinion: "Review opinion",
    reviewTime: "Review Time",
    opinionCanNotNull: "Review opinion can not be blank",
    reviewInfo1: "Confirmation passed？",
    reviewInfo2: "Confirmation refuse？",
    downloadList: "Download list",
    reviewRefuse: "Review Refuse",
    batchReview: "Batch review",
    batchPass: "Batch Pass",
    batchRefuse: "Batch Refuse",
    noReviewData: "No review data",
    downStart: "Start down",
    downEnd: "End down",
    modelEffectiveDays: "Model effective days",
    isExpired: "Is expired",
    forever: "forever",
    releaseDetail: "Release detail",
    releaseStatus_null: "not release",
    releaseStatus_0: "not release",
    releaseStatus_1: "already release",
    releasePlatform: "Release platform",
    releaseTime: "Release time",
    manualRelease: "Manual release",
    notRelease: "NOT release",
    biComparison_1_: "yes",
    biComparison_0_: "no",
    noThing: "noThing",
    reviewDetail: "Review Detail",
    tm: "TM Release",
    tmDate: "Release time",
    cn: "CN.COM Release",
    cnDate: "Release time",
    c4c: "CN.COM Release",
    c4cDate: "Release time",
    cn2: "APP&MNP",
    tm2: "TMALL",
    c4c2: "CN.COM",
    imageType: "Image type",
    tag: "Tag",
    sameTag: "Tag exist！",
  },
  attributeManagement: {
    platform_0: 'CN',
    platform_2: 'TM',
    attributeEdit: "Attribute Edit",
    attribute: "Attribute",
    attrNameEn: "AttrName(EN)",
    attrNameCn: "AttrName(CN)",
    valueSet: "Value Set",
    logic: "logic",
    valueSetEdit: "valueSet Edit",
    attrValueEn: "AttrValue(EN)",
    attrValueCn: "AttrValue(CN)",
    logicEdit: "logic Configuration",
    createBy: "Create User",
    createTime: "Create Time",
    updateBy: "Update User",
    updateTime: "Update Time",
    entityName: "Source",
    validState: "Valid State",
    validState_0: "Not Effective",
    validState_1: "Effective",
    effective: "Effective",
    effectiveResults: "Effective Results",
    resultStatus: "Result Status",
    resultMessage: "Result Message",
    config: "config",
    steps: "Steps",
    stepType_1: "Filter",
    stepType_2: "Switch",
    stepType_3: "Mapping",
    inputFrom: "Input From",
    inputFrom_1: "Pre Step",
    inputFrom_2: "Fields In Source",
    inputFrom_3: "No Source",
    inputLang: "Input Lang",
    inputLang_1: "EN",
    inputLang_2: "CN",
    defaultValue: "Default Value",
    field: "Field",
    operator: "Operator",
    value: "Value",
    logicalSymbol: "Logical Symbol",
    addSubexpression: "Add Subexpression",
    branch: "Branch",
    outputValue: "Output Value",
    returnIfMatch: "Return After Matching",
    returnIfMatch_0: "No",
    returnIfMatch_1: "Yes",
  },
  assetsUploadList: {
    startDate: "Start date",
    endDate: "End date",
    fileType: "File Type",
    all: "All",
    fileType_0_1: "Global Image",
    fileType_0_2: "Sample Image",
    search: "Search",
    reset: "Reset",
    chooseFile: "Choose file",
    loading: "Loading...",
    upload: "Upload",
    uploading: "Uploading...",
    fileName: "File name",
    createBy: "Upload user",
    orgCode: "Upload Organization",
    createTime: "Upload time",
    pleaseChooseFile: "Please choose file!",
    pleaseUploadFile: "Please upload file!",
    uploadSuccess: "Success!",
    uploadSkuList: "Upload SKU list",
    uploadTrackingList: "Upload tracking list",
    uploadCampaignList: "Upload campaign list",
    imageTaskInProcess: 'Image task generation is running at backend , please try later',
    uploadFailed: "Upload failed!",
    updateTask: "Double confirm all the tracking list have be upload",
    uploadAll: "Confirm update all the task?",
    submitSuccess: "Submit successfully, task update is in process!",
    excelIsParsing: "Excel is parsing at backend ,please try later!",
    taskIsRunning: "Task update is running at backend ,please try later!",
    // |||||||||||||||||||||||
  },
  professionalWord:{
    currentPlatformPype: 'Current platform type ',
    and: 'and ',
    deleteInfo: 'Would you want to delete the professional word?',
    professionalWord: 'Professional Word',
    professionalWordEN: 'Professional Word(EN)',
    descriptionEN: 'description(EN)',
    professionalWordZH: 'Professional Word(SC)',
    descriptionZH: 'description(SC)',
    professionalWordTC: 'Professional Word(TC)',
    descriptionTC: 'description(TC)',
  },
  forbiddenWord:{
    currentPlatform: 'Current platform ',
    deleteInfo: 'Would you want to delete the forbidden word?',
    forbiddenWord: 'SysForbidden Word',
    description: 'description',
  },
  disclaimer:{
    deleteInfo: 'Would you want to delete the disclaimer?',
    disclaimer: 'Disclaimer',
    keyWord: 'Key Word',
    content: 'Content EN',
    contentTranslate: 'Content SC(CN.COM)',
    contentHk: 'Content TC',
    applyEc: 'Apply EC',
    contentTm: 'Content SC(EC)',
    applicableProduct: 'Applicable Product',
    description: 'Title'
  },
  biRepository:{
    biRepository: 'BI Repository'
  },
  sysDict: {
    dict: "Dict",
    dictData: "Data",
    code: "Code",
    name: "Name",
    remark: "Remark",
    detail: "Remark",
    updateBy: "Update User",
    updateTime: "Update Time",
    operation: "operation",
  },
  sysApiInfo: {
    name: "Name",
    url: "URL",
    description: "Description",
    use: "Use",
    update: "Update",
    delete: "Delete",
    useInfo: "useInfo",
    monitor: "monitor",
    configuration: "configuration",
    sentence: "SQLsentence",
  },
  copyBiRule: {
    copyBiRule: 'Copy Bi Rule',
    name : "Rule Name",
    keyWord: "Key Word",
    matchRule: "Match Rules",
    description: "toast",
    deleteInfo: 'Would you want to delete the copy bi rule?',
    imageInfo: 'Image',
    matchRule_0: 'Product Code',
    matchRule_1: 'Category',
    matchRule_2: 'EN Copy',
    matchRule_3: 'ZH Copy',
  },
  imageBiRule: {
    imageBiRule: 'Image Bi Rule',
    type: 'Type',
    title : 'Title',
    keyWord: 'Key Word',
    productList: 'Product List',
    imageInfo: 'Image',
    tag: 'Tag',
    ruleContent: 'Rule Content',
    basicReason: 'Basic Reason',
    legalAdvice: 'Legal Advice',
    deleteInfo: 'Would you want to delete the image bi rule?',
  },
  imageCertificateList: {
    sku: "SKU/STYLE",
    productCode: "SKU",
    productName: "Product name",
    sampleStatus: "Sample",
    sampleStatus_0: "No Sample",
    sampleStatus_1: "In process",
    sampleStatus_2: "Uploaded",
    sampleStatus_3: "Shipped",
    sampleStatus_4: "Simple Filed",
    existCertificate: "Exist Certificate",
    existCertificate_0: "No",
    existCertificate_1: "Yes",
    existShoeBox: "Exist Shoe Box Label",
    existShoeBox_0: "No",
    existShoeBox_1: "Yes",
    sampleBatch: "Sample Batch",
    status: "Status",
    status_0: "To be confirmed",
    status_1: "Confirmed",
    status_2: "Missing",
    updateTime: "Update Time",
    operation: "Operation",
    certificate: "Certificate",
    selectCertificate: 'Select Certificate',
    selectShoeBox: 'Select Shoe Box Label',
    change: 'Change',
    rawImage: 'RAW Image',
  },
  license: {
    uploadSuccess: "Upload Success！"
  },
  sellPoint: {
    fileType_12_1: "video",
    fileType_12_2: "infographic",
    fileType_12_3: "TOP200",
    fileType_12_4: "AR 锚点",
    fileType_12_5: "动态主图",
    fileType_12_6: "Fast",
    fileType_13_1: "video",
    fileType_13_2: "infographic",
    fileType_13_3: "TOP200",
    fileType_13_4: "AR 锚点",
    fileType_13_5: "动态主图",
    fileType_13_6: "Fast",
    status: 'status',
    status_0: 'pending',
    status_1: 'accomplish',
    status_2: 'error',
    status_3: 'being processed',
    operate: 'Operate',
    uploading: "Uploading...",
  },
  launchTracking: {
    upload: 'Upload',
    fileName: 'File Name',
    uploader: 'Uploader',
    uploadTime: 'Upload Time',
    currentStatus: 'Current Status',
    status: 'Status',
    status_0: 'pending',
    status_1: 'accomplish',
    status_2: 'error',
    status_3: 'being processed',
    headerParsingResult: 'Header Parsing Result',
    isParsed: 'Is Parsed',
    parsed: 'Parsed',
    skipped: 'Skipped',
    unparsedData: 'Unparsed Data',
    showLogId: 'Show Log ID:',
    openUploadDialog: 'Open Upload Dialog',
    pleaseChooseFile: 'Please choose file',
    taskProcessing: 'Task Processing',
    fileListUpload: 'File List Upload',
    resultUpload: 'Result Upload',
    dataQuery: 'Data Query',
    type: 'Type',
    season: 'Season',
    gender: 'Gender',
    age: 'Age',
    enrichedCopy: "ENRICHED COPY",
    nikeComEcoLaunchDate: 'NIKE.COM ECO LAUNCH DATE',
    productNameInProdigy: 'PRODUCT NAME IN PRODIGY',
    platform: 'Platform',
    launchType: 'LAUNCH TYPE',
    fullColorDescription: 'FULL COLOR DESCRIPTION',
    taskStatus: 'TASK STATUS',
    enrichedCopyDelivered1: 'ENRICHED COPY DELIVERED 1',
    enrichedCopyDelivered2: 'ENRICHED COPY DELIVERED 2',
    updateTime: 'UPDATE TIME',
    comments: 'Comments',
    publishStatus: 'PUBLISH STATUS',
    publishTime: 'PUBLISH TIME',
    uploadPerson: 'Upload Person',
    operation: 'Operation',
    pleaseSelectFileType: 'Please select file type',
    addingSuccess: 'Add success!',
    addingFailed: 'Add failed!',
    enrichedCopyDelivered1Required: 'Please enter enrichedCopyDelivered1',
    enrichedCopyDelivered2Required: 'Please enter enrichedCopyDelivered2',
    publishStatusList: 'Publish Status',
    publishStatusList_null: '',
    publishStatusList_0: 'Pending release',
    publishStatusList_1: 'Released',
    taskStatusList: 'Task Status',
    taskStatusList_null: '',
    taskStatusList_0: 'To be distributed',
    taskStatusList_1: 'Distributed',
    taskStatusList_2: 'Expired',
    uploadStatus: 'UPLOAD STATUS',
    uploadStatus_null: '',
    uploadStatus_0: 'To be uploaded',
    uploadStatus_1: 'Uploaded',
    uploadStatus_2: 'Upload Exception',
    uploadStatus_3: 'Upload Processing',
    resultPublishTime: 'UPLOAD TIME',
    dueDate: 'Due Date',
    inventoryStatus: 'Inventory Status',
    translateStatus: 'Translation Status',
    copyStatus: 'Copy Status',
    copyStatus_0: 'No',
    copyStatus_1: 'Yes',
    copyStatus_2: 'No (CopyWritting)',
    copyStatus_3: 'No (With translation and inventory)',
    copyStatus_4: 'No (With translation, no inventory)',
    copyStatus_5: 'No (No translation, with inventory)',
    copyStatus_6: 'No (No translation, no inventory)',
    archiveConfirm: 'Are you sure you want to archive the selected content?',
    fileList: 'File List',
    taskAssignment: 'Task Assignment',
  },
  keyWords:{
    status: 'status',
    status_0: 'pending',
    status_1: 'accomplish',
    status_2: 'error',
    status_3: 'being processed',
    publishInfo: 'Please select the data to be published',
    publishTime: 'Publish Time',
    publishReason: 'Publish Reason',
    uploadTime: 'Upload Time',
    keywordsPublishInfo: 'Keyword Publishing Details',
    keywordsUploadInfo: 'Keywords Upload Details',
    copyPublishDetail: 'Copy Publish Detail',
    keywordsStatus_0: 'being processed',
    keywordsStatus_1: 'accomplish',
    publishOk: "Publish success!",
    publishError: "Release failed, please try later",
    reportStatistics: 'Report Statistics',
    season: 'Season',
    noAccessed: "No available copy",
    releaseStatus_null: 'ALL',
    releaseStatus_0: 'not release',
    releaseStatus_1: 'already release',
    platform: 'Platform',
    planning: 'Whether released based on planning',
    detailReleaseStatus_null: '',
    detailReleaseStatus_0: 'being processed',
    detailReleaseStatus_1: 'accomplish',
    detailReleaseStatus_2: 'Skip',
  },
  measurement:{
    status_0: 'pending',
    status_1: 'accomplish',
    status_2: 'error',
    status_3: 'being processed',
    operate: 'Operate',
    published: "Published",
    unpublished: "Unpublished",
    uploading: "Uploading...",
    pleaseChooseFile: "Please choose file!"
  },
  infographicTask: {
    fileUpload: 'File Upload',
    dataManage: 'Data Management',
    ChooseFile: 'ChooseFile',
    productName: 'Product Name',
    upload: 'Upload',
    search: 'Search',
    download: 'Data Download',
    downloadImage: 'Image Download',
    selSeason: 'Please select season',
    excelName: "File name",
    createUser: "Operator",
    createTime: "Upload time",
    status: 'Status',
    status_0: 'pending',
    status_1: 'accomplish',
    status_2: 'error',
    status_3: 'being processed',
    addSeason: 'Add Season',
    editSeason: 'Edit Season',
    season: 'season',
    tryToFeel: "Try To Feel",
    pleaseChooseFile: "Please choose file!",
    uploading: "Uploading...",
    saveInfo: "Do you want to save?",
    saveInfoIsNull: "The content cannot be empty,please input!",
    productCategory: "product category",
    fitExperience: "fit experience",
    customerFeedback: "customer feedback",
    commentCount: "comment count",
    diagnosisStatus: "diagnosis status",
    negativeJudgement: "negative judgement",
    newSeason: "new season",
    publishStatus: "publish status",
    operate: "operate",
    pleaseChooseDetail: "Please choose detail!",
    downloadFailed: "Download Failed!",
    detail: "detail",
    published: "Published",
    unpublished: "Unpublished",
    normal: "Normal",
    abnormal: "Abnormal",
    warning: "Warning",
    noFeedback: "No Feedback"
  },
  labelManagement: {
    season: "Season",
    style: "Style",
    keywords: "keyWords",
    sellingPointsLabel: "selling points tags",
    configuration: "configuration",
    label: 'tag',
    date: "Date",
    blank: "blank",
    associated: "Associated",
    unassociated: "Unassociated",
    newTagging: 'New Tagging',
    selectTagging: 'Select Tagging',
    customTags: "Custom Tags",
    newSeason: "New Season",
    seasons: "Season",
    createTime: "Create Time",
    deleteInfo: "Would you want to delete the season?",
    deleteInfoTag: "Would you want to delete the tag?",
    enterSeasonName: "Please enter the season name",
    selectTag: "Please select tag",
    pleaseEnterTagName: "Please enter tag name",
    seasonExist: "Season exists！",
    enterTag: "Please enter the tag",
    tagInfoIsNull: "The content cannot be empty!",
  },
  sizeAndFit: {
    downloadList: "Download list",
    batchReCheck: "Batch Recheck",
    batchReview: "Batch Review",
    status: "Status",
    status_null: "All",
    status_0: 'To be reviewed',
    status_1: 'To be rechecked',
    status_2: 'Reviewed',
    detail: "Detail",
    createBy: "CreateBy",
    createTime: "Create Time",
    excelName: "Excel Name",
    upload: 'Upload',
    dataManage: "Data Manage",
    fileUpload: 'File Upload',
    season: "Season",
    submit: "Submit",
    pass: "Pass",
    refuse: "Refuse",
    previous: "Previous",
    next: "Next",
    close: "Close",
    recall: "Recall",
    reviewSuccess: "Review Success",
    reviewFailed: "Review Failed",
    reviewConfirm: "Are you sure to pass all the Data?",
    noReviewData: "There is no audit data for the current record, and it cannot be audited for the time being?",
    noRecheckData: "There is no review data for the current record and it cannot be audited for the time being?",
    selectedUpload: 'File upload failed, please contact your administrator！',
    submitInfo: 'Do you want to submit the current page data?',
    startDate: "Start date",
    endDate: "End date",
    reviewType_null: "",
    reviewType_0: 'Review',
    reviewType_1: 'Recheck',
  },
  errorTicket: {
    status: "Status",
    status_null: "All",
    status_0: "Pending",
    status_1: "Accomplish",
    status_2: "Close",
    urgent: "Urgent",
    Urgent: "Urgent",
    CancelUrgent: "Cancel Urgent",
    urgent_null: "All",
    urgent_1: "Y",
    urgent_0: "N",
    detail: "Detail",
    download: "DownLoad Report",
    downLoadList: "Download List",
    close: 'Close',
    urgentConfirm: "Are you sure to expedite this data?",
    closeInfo: 'Are you sure to close all queried data?',
    closeData: "Are you sure to close the",
    data: "piece of data?",
    selectedReport: 'There is no Error Ticket report for the selected data!',
    noReviewData: "No review data",
    noRecheckData: "No recheck data",
    cancelUrgentConfirm: "Are you sure to cancel the urgent data?",
  },
  storeManage: {
    storeMaintenance: "Store Maintenance",
    productName: "Product Name",
    productType: "Product Type",
    productCategory: "Product Category",
    genderGroup: "Gender Group",
    store: "Store",
    upShelves: "Up Shelves",
    downShelves: "Down Shelves",
    shelves: "Shelves",
    maintainInfo: "Are you sure to maintain the ",
    data: " pieces of data?",
    selectSeason: "Please select season",
    selectStore: "Please select stores",
    selectShelves: "Please select whether or not to list",
    selectedReport: 'The selected data has not yet generated an error ticket report file.Please try again later!'
  },
  HWTable: {
    fileName: 'file Name',
    platform: 'platform',
    createUser: 'create User',
    createTime: 'create Time',
    status: 'status',
    status_0: 'pending',
    status_1: 'accomplish',
    status_2: 'error',
    status_3: 'being processed',
    ChooseFile: 'Choose File',
    uploadImage: 'upload Image',
    releaseNow: 'release Now',
    release: 'release',
    isMissing: 'is Missing',
    download: 'download',
    batchEdit: "Batch edit",
    productName: 'Product name',
    productType: 'Product type',
    toMails: 'Email TO',
    ccMails: 'Email CC',
    bccMails: 'Email BCC',
    selectPlatform: "Select platform",
    selectToMails: 'Select to mails',
    EditAllData: 'Are you sure to edit all the queried data？',
    tableInfo: 'please select H/W Table',
    publishOk: "Release Successfully",
    publishError: "Release failed, please try later",
    publishAllData: 'Are you sure to publish all the queried data？',
    uploading: "Uploading...",
    selectedUpload: 'upload Successfully',
    noFileInfo: 'There are no files available for download',
    releaseStatus_null: "not release",
    releaseStatus_0: "not release",
    releaseStatus_1: "already release",
    releaseStatus_999: "-",
    releasePlatform: "Release platform",
    deleteInfo: 'Are you sure to delete this image？',
    saveSuccess: "Save Success",
    saveFailed: 'Save Failed',
    noImageInfo: 'There are no images available for delete',
    noImage: 'No Image',
    Publish: 'Publish',
    publishInfo: 'Task creation successfully published',
    publishFailedInfo: 'Task creation failed to publish',
    editInfo: 'No operable data found'
  },
  colorDescription: {
    fileName: 'file Name',
    platform: 'platform',
    createUser: 'create User',
    createTime: 'create Time',
    status: 'status',
    status_0: 'pending',
    status_1: 'accomplish',
    status_2: 'error',
    status_3: 'being processed',
    ChooseFile: 'Choose File',
    uploadImage: 'upload Image',
    releaseNow: 'release Now',
    release: 'release',
    isMissing: 'is Missing',
    download: 'download',
    batchEdit: "Batch edit",
    productName: 'Product name',
    productType: 'Product type',
    toMails: 'Email TO',
    ccMails: 'Email CC',
    bccMails: 'Email BCC',
    selectPlatform: "Select platform",
    selectToMails: 'Select to mails',
    EditAllData: 'Are you sure to edit all the queried data？',
    tableInfo: 'please select H/W Table',
    publishOk: "Release Successfully",
    publishError: "Release failed, please try later",
    publishAllData: 'Are you sure to publish all the queried data？',
    uploading: "Uploading...",
    selectedUpload: 'upload Successfully',
    noFileInfo: 'There are no files available for download',
    releaseStatus: "release status",
    releaseStatus_null: "",
    releaseStatus_0: "not release",
    releaseStatus_1: "already release",
    releasePlatform: "Release platform",
    deleteInfo: 'Are you sure to delete this image？',
    saveSuccess: "Save Success",
    saveFailed: 'Save Failed',
    noImageInfo: 'There are no images available for delete',
    noImage: 'No Image',
    Publish: 'Publish',
    publishInfo: 'Task creation successfully published',
    publishFailedInfo: 'Task creation failed to publish',
    editInfo: 'No operable data found',
    searchColor: "Search for main color",
    releaseTime: "release Time"
  },
  listUpload: {
    listUpload: 'List Upload',
    taskGeneration: 'Task Generation',
    translationDownload: 'Translation Download',
  },
  copyReview: {
    uploadStatus: 'Upload Status',
    uploadStatus_null: '',
    uploadStatus_0: 'To be uploaded',
    uploadStatus_1: 'Uploaded',
    uploadDate: 'Upload Date',
    startReview: 'Start Review',
    exceptionalStyle: 'Exceptional Style',
    pleaseSelectExceptionalStyle: 'Please select an Exceptional Style',
    exceptionalStyleAllSelectedTip: 'All styles with uploaded samples cannot be set to Exceptional!',
    nextStep: 'Next',
    prevStep: 'Previous',
    applicableStyle: 'Applicable Style',
    copyUpload: 'Copy Upload',
    taskDetail: 'Task Detail',
    copyType: 'Copy Type',
    backList: "Return Task List",
    takeSample: "Sample",
    translation: "Translation",
    source: "Source",
    linguistiscReview: "Linguistic Review",
    specReview: "Spec Review",
    versionInfo: "Version Info",
    detail: "Detail",
    isSample_true: "Yes",
    isSample_false: "No",
    uploadSuccess: 'Upload successful',
    reviewStatus: 'Review Status',
    reviewStatus_0: "To be reviewed",
    reviewStatus_1: "Reviewed",
    reviewer: 'Reviewer',
    reviewTime: 'Review Time',
    uploadTime: 'Upload Time',
    samplePhotoStatus: 'Sample Photo Status',
    samplePhotoStatus_all: 'All',
    samplePhotoStatus_0: 'Not uploaded',
    samplePhotoStatus_1: 'Uploaded',
    samplePhotoStatus_2: 'Uploaded/Not uploaded',
    samplePhotoStatus_null: '',
    deleteSegmentTitle: 'Delete Segment Confirmation',
    deleteSegmentTip: 'You are about to permanently delete the following copy segment. Please select its module and confirm.',
    systemReference: 'System Reference',
    viewWorkbook: 'View workbook',
    pleaseSelectModule: 'Please select Module',
    selectModule: 'Select module',
  },
  epdCopy: {
    copyVersion: 'Copy Version',
    originalTranslation: 'Original/Translation',
    keyword: 'Keyword',
    phraseProjectName: 'Phrase Project Name',
    enTriggerTime: 'EN Trigger Time',
    reviewTime: 'Review Time',
    reviewer: 'Reviewer',
    deliverStatus: 'Deliver Status',
    deliverStatus_0: 'Undelivered',
    deliverStatus_1: 'Delivered',
    immediateDelivery: 'Immediate Delivery',
    deliverSuccess: 'Delivery Success',
    publishTime: 'Publish Time',
    deliverTime: 'Delivery Time',
    translationCompletionTime: 'Translation Completion Time',
    downloadTime: 'Download Time',
    taskStatus: 'Upload Status',
    taskStatus_0: 'Pending Upload',
    taskStatus_1: 'Uploaded',
    uploadTime: 'Upload Time',
    dataUpload: 'Data Upload',
    reviewStatus: 'Review Status',
    reviewStatus_0: "To be reviewed",
    reviewStatus_1: "Reviewed",
    translationDownload: 'Translation Download',
    workbookUpload: 'Workbook Upload',
  },
}



// WEBPACK FOOTER //
// ./src/i18n/lang_en.js